import ChatBubble from './chatBubble';

export default ChatBubble;
